<template>
  <div>
    <el-form
      class="login-form form-custom"
      :class="{ 'mgb-reset': !isIndex, 'is-dialog': isDialog }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-form-item class="form-item-primary" prop="email">
        <!-- 邮箱 -->
        <BaseInput
          v-model.trim="form.email"
          :autofocus="!isMobile"
          @blur="setAccount(form.email)"
          @keyup.enter.native="accountNext"
          :validate-event="Boolean(form.email)"
          :placeholer="$t('login.register.enterYourEmail')"
        />
      </el-form-item>
    </el-form>

    <el-button
      class="button-custom"
      :class="{ 'is-dialog': isDialog }"
      @click="accountNext"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.continue`,
      }"
    >
      {{ $t('login.loginPage.continue') }}
    </el-button>

    <!-- <BaseLine :text="$t('login.register.or')" /> -->
    <OtherLogin />
  </div>
</template>

<script>
import BaseMixin from '@/mixins/BaseMixin'
import AccountMixins from '@/mixins/AccountMixins.js'
import RegisterStepAccountMixin from '../mixins/RegisterStepAccountMixin'
import { checkEmail } from '@/utils/validate-rules'
import store from '@/store'
export default {
  name: '',
  mixins: [BaseMixin, AccountMixins, RegisterStepAccountMixin],
  data() {
    return {
      form: {
        email: '',
      },
    }
  },

  computed: {
    rules() {
      return {
        email: [
          {
            required: true,
            message: this.$t('login.register.inputEmail'),
          },
          {
            validator: async (rule, value, callback) => {
              if (checkEmail(value.toLowerCase())) {
                // 检测是否注册
                try {
                  let data = await store.dispatch('CheckUser', {
                    user_name: value,
                  })
                  if (data.data === true) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registered = false
                    return callback()
                  } else {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registered = true
                    return callback(new Error(this.$t('login.register.exists')))
                  }
                } catch (error) {
                  return callback()
                }
              } else {
                return callback(
                  new Error(this.$t('login.register.needCanUseEmail'))
                )
              }
            },
            trigger: ['blur'],
          },
        ],
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.form-custom {
  margin-top: 40px;
  margin-bottom: 40px;
}
.form-custom.is-dialog {
  margin-top: 0;
  margin-bottom: 12px;
}
.is-dialog {
  margin-bottom: 23px;
}
</style>
